<template>
  <div />
</template>

<script>
export default {
  name: 'RegisterByGoogle'
}
</script>

<style scoped>

</style>
